"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainBanner = void 0;
var MainBanner_1 = require("./MainBanner");
Object.defineProperty(exports, "MainBanner", { enumerable: true, get: function () { return __importDefault(MainBanner_1).default; } });
